import { Collection, Space } from '@tribeplatform/gql-client/types'

export const NO_COLLECTION_ID = 'no-collection'

export enum CollectionMenuViewStyle {
  Simple = 'simple',
  Collapsible = 'collapsible',
  Heading = 'heading',
}

export enum CollectionMenuSpaceFilter {
  All = 'all',
  Joined = 'joined',
  NotJoined = 'notJoined',
}

export type CollectionMenuItem = {
  id: string
  enabled: boolean
}

export type CollectionMenuDetailedItem = CollectionMenuItem & {
  name: string
}

export type CollectionMenuProps = {
  items?: CollectionMenuItem[]
  viewStyle: CollectionMenuViewStyle
  spaceFilter?: CollectionMenuSpaceFilter
}

export type NoCollectionEntry = {
  id: typeof NO_COLLECTION_ID
  name: string
  customOrderingIndex: number
  spaces?: {
    nodes: Space[]
    totalCount: number
  }
}

export type CollectionMenuEntry = Collection | NoCollectionEntry

export const isNoCollectionEntry = (
  entry: CollectionMenuEntry,
): entry is NoCollectionEntry => entry.id === NO_COLLECTION_ID

export const getCollectionMenuEntrySpaces = (
  entry: CollectionMenuEntry,
): Space[] =>
  isNoCollectionEntry(entry)
    ? (entry.spaces?.nodes ?? [])
    : (entry.spaces?.edges?.map(({ node }) => node) ?? [])
